import { useEffect, useState } from "react";
import { GenerateTicketApi, GetAllTicketApi, GetTicketPriorityApi, GetTicketQueryTypeApi } from "../../../../api/request/support";
import { useNavigate } from "react-router-dom";
import { Form, Input, Select } from "antd";
import moment from "moment";
import Eye from "../../../../assets/Eye";
import toast from "react-hot-toast";
import ModalComponent from "../../../../components/modals/ModalComponent";
import TextArea from "antd/es/input/TextArea";
import LoadableButton from "../../../../components/buttons/LoadableButton";
import Faq from "../../faq/Faq";
import Pagination from '../../../../components/pagination/Pagination';
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import columns from "../../../../columns/tickets";
export default function Support2() {
    
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isAddTicketLoading, setIsAddTicketLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [queryOptions, setQueryOptions] = useState([]);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const [data, setData] = useState([]);
  const [initialValues, setInitialValues] = useState({ title: '', ticketQueryId: null, description: '', priorityId: null });

  const getColor = (priority) => {
    switch (priority) {
      case 'High':
        return '#ef6464';
      case 'Medium':
        return '#e7c553';
      case 'Low':
        return '#2d9b63';
    }
  }


  const getAllTickets = async () => {
    try {
      setIsLoading(true);
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        IsIb: false,
      }
      const { data } = await GetAllTicketApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: `${item?.firstName} ${item?.lastName}`,
              createdAt: item?.createdDate ? moment(item?.createdDate).format('DD-MM-YYYY LT') : null,
              priority: (<p className='uppercase font-bold text-sm' style={{ color: getColor(item?.priority) }}>{item?.priority}</p>),
              status: (item?.status == 'Open' ? (<span className='px-3 py-1 rounded-full uppercase text-xs text-center success_tag'>{item?.status}</span>) : (<span className='uppercase px-3 py-1 rounded-full text-xs text-center fail_tag'>{item?.status}</span>)),
              details: (<div className='cursor-pointer ' onClick={() => navigate(`/view_ticket2/${item?.ticketId}`)} src='/assets/icons/eye.svg' alt='icon' ><Eye /></div>),
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getAllTickets();
  }, [page, pageSize]);

  useEffect(() => {
    form.resetFields();
  }, [isOpenModal])

  const handleSubmit = async (value) => {
    try {
      setIsAddTicketLoading(true);
      const { data } = await GenerateTicketApi(value);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        getAllTickets();
        setIsOpenModal(false);
      }
      setIsAddTicketLoading(false);
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      setIsAddTicketLoading(false);
    }
  }

  const getTicketQueryType = async () => {
    try {
      let params = { QueryType: 'user' }
      const { data } = await GetTicketQueryTypeApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setQueryOptions(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.queryName })));
      }
    } catch (error) { }
  }

  const getTicketPriority = async () => {
    try {
      const { data } = await GetTicketPriorityApi();
      if (data?.success) {
        setPriorityOptions(data?.data?.map((item) => ({ ...item, value: item?.priorityId, label: item?.priorityName })));
      }
    } catch (error) { }
  }

  const addTicketModalHandler = () => {
    setIsOpenModal(true);
    getTicketQueryType();
    getTicketPriority();
  }
  return(
   <>
    <div className="grid grid-cols-1 xl:grid-cols-12 gap-4 mt-5">
    <div className="xl:col-span-7 rounded-xl w-full">
        <div className="flex justify-between items-center px-4 lg:px-3 pb-6">
          <p className="text-[#2F2B3D] text-lg font-semibold">Ticket List</p>
          <button
            className="bg-primary text-sm text-white font-medium uppercase px-6 py-2 rounded-lg themeHover duration-500"
            onClick={addTicketModalHandler}
          >
            Create Ticket
          </button>
        </div>

   <div className=''>
             <div className="border border-gray-200 rounded-xl">
                 <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
             </div>
             <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
           </div>
  </div>
  <div className='xl:col-span-5'>
   <Faq/>
     </div>
       <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Create Ticket' width={650}>
         <Form className='w-full' autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
           <div className='input-white'>
             <label className='text-base text-[#2F2B3DCC] font-medium'>Title</label>
             <Form.Item name="title" rules={[{ required: true, message: 'Please enter ticket title.' }]}>
               <Input placeholder="Title" className="mt-1 w-full ps-4 py-2" />
             </Form.Item>
           </div>
           <div className='input-white mt-4'>
             <label className='text-base text-[#2F2B3DCC] font-medium'>Description</label>
             <Form.Item name="description" rules={[{ required: true, message: 'Please enter ticket description.' }]}>
               <TextArea placeholder="Description" autoSize={{ minRows: 3, maxRows: 5 }} />
             </Form.Item>
           </div>
           <div className='ant-select-selector-white mt-4'>
             <label className='text-base text-[#2F2B3DCC] font-medium'>Query Type</label>
             <Form.Item name="ticketQueryId" rules={[{ required: true, message: 'Please select a query type.' }]}>
               <Select placeholder='Select query type' className='w-full mt-1' options={queryOptions} />
             </Form.Item>
           </div>
           <div className='ant-select-selector-white mt-4'>
             <label className='text-base text-[#2F2B3DCC] font-medium'>Priority Type</label>
             <Form.Item name="priorityId" rules={[{ required: true, message: 'Please select a priority.' }]}>
               <Select placeholder='Select priority' className='w-full mt-1' options={priorityOptions} />
             </Form.Item>
           </div>
           <div className='mt-6 flex justify-end'>
             <LoadableButton
               className='bg-primary text-sm text-white font-medium uppercase px-8 py-2 rounded-lg themeHover duration-500'
               disabled={isAddTicketLoading}
               type="Submit"
               lable='Save'
               isLoading={isAddTicketLoading}
               loadingLable='Adding ticket...'
             />
           </div>
         </Form>
     </ModalComponent>
  </div>
 </>
 )
}